import type { ISbRichtext } from '@storyblok/js';

export function addQuotes(text: ISbRichtext, mode: 'append' | 'prepend' | 'both'): ISbRichtext {
	const withQuote = structuredClone(text);

	if (['prepend', 'both'].includes(mode)) {
		const first = withQuote.content?.at(0);

		if (first && first.content && first.content.length > 0) {
			first.content[0].text = '“' + first.content[0].text;
		}
	}

	if (mode === 'append' || mode === 'both') {
		const last = withQuote.content?.at(-1);

		if (last && last.content && last.content.length > 0) {
			last.content[0].text = last.content[0].text + '”';
		}
	}

	return withQuote;
}
